import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb } from 'semantic-ui-react';
import classnames from 'classnames';
import './HeaderNavigation.scss';
import { isEmbeddedInCommandCenter } from 'util/commandCenter';
import { MdChevronLeft } from 'react-icons/md';

function HeaderNavigation({ viewForms, goToPayments, paymentsHref }) {
  const onPaymentsClick = useCallback(() => {
    if (viewForms) {
      goToPayments();
    }
  }, [goToPayments, viewForms]);

  if (isEmbeddedInCommandCenter() && viewForms) {
    return (
      <button
        className="header-navigation-back-button cc-button-outlined"
        onClick={onPaymentsClick}
      >
        <MdChevronLeft className="header-navigation-button-icon" />
        Back to Desking
      </button>
    );
  }

  const renderChairmanNav = () => (
    <>
      <Breadcrumb.Section href="/dashboard">Dashboard</Breadcrumb.Section>
      <Breadcrumb.Divider />
      <Breadcrumb.Section
        href={paymentsHref}
        active={!viewForms}
        onClick={onPaymentsClick}
      >
        Payments
      </Breadcrumb.Section>

      {!!viewForms && (
        <>
          <Breadcrumb.Divider />
          <Breadcrumb.Section active={viewForms}>Forms</Breadcrumb.Section>
        </>
      )}
    </>
  );

  const renderCCNav = () => (
    <>
      <Breadcrumb.Section>Deals</Breadcrumb.Section>
      <Breadcrumb.Divider />
      <Breadcrumb.Section>Desking</Breadcrumb.Section>
    </>
  );

  return (
    <Breadcrumb
      size="big"
      className={classnames(
        'header-navigation',
        viewForms && 'header-navigation-no-padding',
      )}
    >
      {!isEmbeddedInCommandCenter() && renderChairmanNav()}
      {isEmbeddedInCommandCenter() && renderCCNav()}
    </Breadcrumb>
  );
}

HeaderNavigation.propTypes = {
  paymentsHref: PropTypes.string,
  goToPayments: PropTypes.func,
  viewForms: PropTypes.bool,
};

export default HeaderNavigation;
